<div class="container">
    <div class="row align-items-center mt-4" [formGroup]="form">
        <div class="col-12">
            <h4 *ngIf="isEdit==false">Novo Usuário</h4>
            <h4 *ngIf="isEdit">Editar Usuário</h4>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-2">
            <label for="">CWID</label>
            <input type="text" class="form-control" formControlName="cwid">
        </div>
        <div class="col-4 ">
            <label for="">Nome</label>
            <input class="form-control" formControlName="name">
        </div>
        <div class="col-4 ">
            <label for="">Email</label>
            <input class="form-control" formControlName="email">
        </div>
        <div class="col-2 mt-5">

            <mat-checkbox formControlName="admin"> Admin
            </mat-checkbox>
        </div>

        <div class="col-6 mt-4 text-left">
            <button class="btn btn-secondary col-6" (click)="backList()">Voltar</button>
        </div>
        <div class="col-6 mt-4 text-right">
            <button class="btn btn-success col-6" (click)="saveUpdate()">Salvar</button>
        </div>


    </div>
</div>